export default __webpack_public_path__ + "static/media/warning.8b7a1e33.svg";